import { useApi } from "@shopexperts/shared";
import { useQuery } from "@tanstack/vue-query";
import { computed } from "vue";

export function usePageTags() {
  const api = useApi();

  const query = useQuery({
    queryKey: ["admin", "pages", "tags"],
    queryFn: () => api.admin.pages.listTags(),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return {
    tags: computed(() => query.data.value || []),
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
